module.exports = "/images/signature.jpg?273f5040f63a6ac9310e41c0418b5d1f";